export default "__VITE_ASSET__P4oz_gjl__"